module.exports = "/assets/js/1060f8d708ffe69f643f66d96e2ed7e5.svg";